import React from 'react';
import Typography from '@mui/material/Typography';

const ISOColumns: React.FC = () => {
  return (
    <>
      <div className='hb-title-col'>
        <Typography className='hb-title-typo'>ISO Control Family</Typography>
      </div>
      <div className='hb-title-col'>
        <Typography className='hb-title-typo'>ID</Typography>
      </div>
      <div className='hb-title-col'>
        <Typography className='hb-title-typo'>Control Name</Typography>
      </div>
      <div className='hb-title-col'>
        <Typography className='hb-title-typo'>Description</Typography>
      </div>
    </>
  );
};

export default ISOColumns;
